import {AppState} from './../../../store';
import {createSelector} from 'reselect';

export const shareHotelSelector = (state: AppState) => state.share;

export const shareHotelListSelector = createSelector(shareHotelSelector, item => item.shareHotelsList);
